import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Progress,
  Row,
} from "reactstrap";
import CommonModal from "../../../../CommonElements/Functions/CommonModels";
import {
  getData,
  postData,
} from "../../../../CommonElements/Functions/PostGetFun";
import { CustomProgressType } from "../../../../Types/MiscellaneousType";
import { API } from "../../../../api/API";
import CommonTable from "../../../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import TreeModel from "./TreeModel";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DARReport from "../../../Reports/DARReport";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import FeatherIconCom from "../../../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import CommonTableNew from "../../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import { H2, H3, H5, H6, Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Utils";
import { getActivePermKeysFromDexie } from "../../../../db/DexieServises";
import Slider from "react-slick";
import { Activity, User } from "react-feather";
import { discountSliderOptions } from "../../../../Data/DashboardsData/ECommerceData";
import DiscountCard from "../../../../Utils/CommonComponents/DashboardsCommon/EcommerceCommon/DiscountCard";
import SvgIcon from "../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import CustomerCard from "../../../../Utils/CommonComponents/DashboardsCommon/DefaultCommon/CustomerCard";
import { customerCardData } from "../../../../Data/DashboardsData/DefaultData";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux-toolkit/store";
export function CustomProgress({ value, color }: CustomProgressType) {
  return (
    <div className="progress-showcase" style={{ width: "86px" }}>
      <Progress className="sm-progress-bar" value={value} color={color} />
    </div>
  );
}
export interface AttendanceDataRow {
  fullName: string;
  position: string;
  attendanceStatus: string;
  BeatNamesWithCount: string;
  positionId: number; // 👈 Add this
  ActualBeatNamesWithCount: string;
  empcode: string;
  empid: string;
  travelTown: string;
  travelTime: string;
  orderTotal: number;
  AttendanceDate: string;
  TravelledDistance: string;
}
export interface CallseDataRow {
  ["Beats.BeatName"]?: string;
  OutletTypeName?: string;
  OutletName?: string;
  VisitFq?: string | number;
}

export interface CallseDataRow1 {
  OutletTypeName?: string;
  OutletName?: string;
  DcrStatus?: string;
}

type AttendanceTableProps = {
  startDate: string; // or Date, depending on your data type
};

export default function AttendanceTable({ startDate }: AttendanceTableProps) {
  const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);
  const [attendanceTable, setAttendanceTable] = useState<AttendanceDataRow[]>(
    [],
  );
  const [callsTable, setcallsTable] = useState<CallseDataRow[]>([]);
  const [callsTable1, setcallsTable1] = useState<CallseDataRow1[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPositionId, setSelectedPositionId] = useState<number | null>(
    null,
  );
  const [modalOpen1, setModalOpen1] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(attendanceTable);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loadingRef, setLoadingRef] = useState(true);

  console.log(selectedIds, "selectedIds attendance");
  const serverUrl = localStorage.getItem("serverUrl");
  const myEmpId = localStorage.getItem("empId");
  const unitId = useSelector((state: RootState) => state.orgUnit.id);
  const orgUnitId = localStorage.getItem("orgUnitId");
  const APP_TOKEN = localStorage.getItem("appToken") || false;

  const [selectedEIds, setSelectedEIds] = useState<string[]>([]);
  const handleCheckboxChange = (empid: string) => {
    setSelectedEIds((prev) =>
      prev.includes(empid)
        ? prev.filter((id) => id !== empid)
        : [...prev, empid],
    );
  };

  const handleSubmit = async () => {
    // console.log('Selected employee IDs:', selectedEIds);
    // console.log('Title:', title);
    // console.log('Message:', message);
    const url = `${serverUrl}${API.sendPushNotification}`;
    const APP_TOKEN = localStorage.getItem("appToken") || false;
    const csvString = selectedEIds.map(String).join(",");
    // console.log('Comma-separated IDs:', csvString); // "7346,7450"
    if (!serverUrl || !APP_TOKEN) {
      console.error("❌ Missing server URL or app token");
      return;
    }
    const { status, data } = await postData(url, true, {
      employee_ids: csvString,
      pushnotification_title: title,
      pushnotification_message: message,
    });
    // console.log(data, 'data');
    if (status === 200) {
      toast.success(data.message);
    } else {
      toast.error(data.message);
    }

    // Optionally close modal
    setModalOpen2(false);

    // Reset inputs if needed
    setTitle("");
    setMessage("");
  };
  // Filter whenever attendanceTable or searchText changes
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);

  // 🚀 This runs whenever search text, selectedIds, or selectedStatus changes
  // It filters the attendanceTable and updates filteredData accordingly.
  useEffect(() => {
    const lower = searchText.toLowerCase();

    const filtered = attendanceTable.filter((item) => {
      const matchesSearch =
        item.fullName.toLowerCase().includes(lower) ||
        item.BeatNamesWithCount.toLowerCase().includes(lower) ||
        item.ActualBeatNamesWithCount.toLowerCase().includes(lower) ||
        item.position.toLowerCase().includes(lower) ||
        item.empcode.toLowerCase().includes(lower) ||
        item.attendanceStatus.toLowerCase().includes(lower) ||
        item.travelTown.toLowerCase().includes(lower);

      const matchesSelection =
        selectedIds.length === 0 || selectedIds.includes(item.positionId);

      const matchesStatus =
        selectedStatuses.length === 0 ||
        selectedStatuses.includes(item.attendanceStatus);

      return matchesSearch && matchesSelection && matchesStatus;
    });

    setFilteredData(filtered);
  }, [searchText, attendanceTable, selectedIds, selectedStatuses]);

  const attendanceStats = useMemo(() => {
    const stats: Record<string, number> = {};
    attendanceTable.forEach((item) => {
      const status = item.attendanceStatus || "Unknown";
      stats[status] = (stats[status] || 0) + 1;
    });
    return stats;
  }, [attendanceTable]);

  // 🪄 Toggle a status in/out of the selection
  const toggleStatus = (status: string) => {
    setSelectedStatuses((prev) => {
      if (prev.includes(status)) {
        // if already selected → remove
        return prev.filter((s) => s !== status);
      } else {
        // if not selected → add
        return [...prev, status];
      }
    });
  };

  // 🔄 Reset all
  const resetStatuses = () => setSelectedStatuses([]);

  const handleSubmitAPI = async () => {
    if (!serverUrl || !APP_TOKEN) {
      console.error("❌ Missing server URL or app token");
      return;
    }
    const url = `${serverUrl}${API.getTeamAttendance}`;
    console.log(url, startDate, 'url serverurl startDate');
    setLoading(true);
    const params: any =
      String(unitId) === String(orgUnitId)
        ? { date: startDate }
        : { date: startDate, org_unit_id: unitId };

    const { status, data } = await getData(url, true, params);
    // console.log(data.data, 'data');
    const formatTime = (timeStr: string) => timeStr?.slice(0, 5) || "";
    function formatTo12Hour(timeStr: string): string {
      if (!timeStr) return "";
      const [hours, minutes] = timeStr.split(":");
      const date = new Date();
      date.setHours(parseInt(hours), parseInt(minutes));

      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    }

    function formatDateToDDMMMYYYY(dateStr: string): string {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return ""; // handle invalid dates
      return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(date);
    }

    if (status === 200 && Array.isArray(data?.data) && data.data.length > 0) {
      if (data.data.length > 0) {
        const cleanedData: AttendanceDataRow[] = data.data.map((item: any) => ({
          fullName: `${item.FirstName ?? ""} ${item.LastName ?? ""}`,
          position: item.PositionName ?? "",
          empcode: item.EmployeeCode ?? "",
          empid: item.EmployeeId ?? "",
          attendanceStatus: item.AttendanceStatus ?? "",
          travelTown: `${item.StartTown ?? ""} → ${item.EndTown ?? ""}`,
          travelTime:
            item.StartTime || item.EndTime
              ? `${formatTo12Hour(item.StartTime)} → ${formatTo12Hour(
                  item.EndTime,
                )}`
              : "",
          orderTotal: item.OrderTotal ?? 0,
          positionId: item.PositionId ?? 0,
          TravelledDistance: item.TravelledDistance ?? "",
          BeatNamesWithCount: item.BeatNamesWithCount ?? "",
          ActualBeatNamesWithCount: item.ActualBeatNamesWithCount ?? "",
          AttendanceDate: formatDateToDDMMMYYYY(item.AttendanceDate ?? ""),
        }));
        setAttendanceTable(cleanedData);
      } else {
        // 👇 This ensures old data is cleared when no data is returned
        setAttendanceTable([]);
        setFilteredData([]);
        setSelectedEIds([]); // Optional: also clear selected checkboxes
      }
      setLoading(false); // 👈 Stop loader
    } else {
      console.error("❌ Failed to fetch or no data");
    }
    setLoading(false); // 👈 Stop loader
  };
  const fetchTourPlan = async (type: "planned" | "actual") => {
    if (!selectedPositionId) return;
    if (!serverUrl || !APP_TOKEN) return;
    setLoading(true);
    const url = `${serverUrl}${
      type === "planned" ? API.getTourPlan : API.getActualTourPlan
    }`;
    const { status, data } = await getData(url, true, {
      position_id: selectedPositionId,
      date: startDate,
    });

    if (status === 200 && Array.isArray(data?.data)) {
      setLoading(false);
      if (type === "planned") setcallsTable(data.data);
      else setcallsTable1(data.data);
    }
    setLoading(false);
  };
  const [reportData, setReportData] = useState<{
    positionId: string;
    startDate: string;
  }>({
    positionId: "",
    startDate: "",
  });

  const handleOpenModal = (positionId: number | string, startDate: string) => {
    setReportData({
      positionId: String(positionId),
      startDate,
    });
    setModalOpen1(true);
  };
  useEffect(() => {
    if (modalOpen) fetchTourPlan("planned");
  }, [modalOpen, selectedPositionId]);
  useEffect(() => {
    if (modalOpen1) fetchTourPlan("actual");
  }, [modalOpen1, selectedPositionId]);

  useEffect(() => {
    setAttendanceTable([]);
    setFilteredData([]);
    setSelectedEIds([]);
    handleSubmitAPI();
  }, [startDate, loadingRef, unitId]);

  const allSelected =
    filteredData.length > 0 &&
    filteredData.every((item) => selectedEIds.includes(item.empid));
  const someSelected = filteredData.some((item) =>
    selectedEIds.includes(item.empid),
  );

  const selectAllRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = someSelected && !allSelected;
    }
  }, [someSelected, allSelected]);

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      const allIds = filteredData.map((item) => item.empid);
      setSelectedEIds(allIds);
    } else {
      setSelectedEIds([]);
    }
  };

  const tableHeadData = [
    {
      id: "1",
      head: (
        <input
          ref={selectAllRef}
          type="checkbox"
          checked={allSelected}
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      key: "empid",
      sortKey: null,
    },
    { id: "2", head: "Employee Code", key: "empcode", sortKey: "empcode" },
    { id: "3", head: "Name", key: "fullName", sortKey: "fullName" },
    { id: "4", head: "Position", key: "position", sortKey: "position" },
    {
      id: "5",
      head: "Attendance Date",
      key: "AttendanceDate",
      sortKey: "AttendanceDate",
    },
    {
      id: "6",
      head: "Attendance Status",
      key: "attendanceStatus",
      sortKey: "attendanceStatus",
    },
    {
      id: "8",
      head: "Start-End Time",
      key: "travelTime",
      sortKey: "travelTime",
    },
    {
      id: "9",
      head: "Start-End Town",
      key: "travelTown",
      sortKey: "travelTown",
    },
    {
      id: "10",
      head: "Total Travelled KM",
      key: "TravelledDistance",
      sortKey: "TravelledDistance",
    },

    {
      id: "11",
      head: "Planned Patch",
      key: "BeatNamesWithCount",
      sortKey: "BeatNamesWithCount",
    },
    {
      id: "12",
      head: "Actual Patch",
      key: "ActualBeatNamesWithCount",
      sortKey: "ActualBeatNamesWithCount",
    },
    { id: "13", head: "POB", key: "orderTotal", sortKey: "orderTotal" },
  ];
  const handleExportToExcel = () => {
    const exportData = filteredData.map((item) => ({
      "Employee Code": item.empcode,
      Name: item.fullName,
      Position: item.position,
      Status: item.attendanceStatus,
      "Start-End Time": item.travelTime,
      "Start-End Town": item.travelTown,
      "Total Travelled KM": item.TravelledDistance,
      "Attendance Date": item.AttendanceDate,
      "Planned Patch": item.BeatNamesWithCount,
      "Actual Patch": item.ActualBeatNamesWithCount,
      POB: item.orderTotal,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `Attendance_Report_${startDate || "Month"}.xlsx`);
  };
  //name: "MTP-Adh",
  const [lockOpenModal, setLockOpenModal] = useState(false);
  const [selectedEmpId, setSelectedEmpId] = useState(null);
  const [remark, setRemark] = useState("");

  const handleSubmits = async () => {
    if (!selectedEmpId) return;
    if (!remark) {
      toast.error("Remark is required");
      return;
    }
    setLoading(true);
    try {
      const url = `${serverUrl}${API.UnlockDays}`;
      const { status, data } = await postData(url, true, {
        employee_id: selectedEmpId,
        remark: remark,
      });
      // console.log(data.data, 'data unlock');
      if (status === 200) {
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
      setLockOpenModal(false);
    } catch (err) {
      console.error(err);
      alert("Failed to unlock.");
    } finally {
      setLoading(false);
    }
  };
  const [permissions, setPermissions] = useState<string[]>([]);
  // console.log(permissions, 'permissions');
  useEffect(() => {
    getActivePermKeysFromDexie().then(setPermissions);
  }, []);

  return (
    <Fragment>
      <div className="row mb-3 align-items-center justify-content-between">
        <div className="col-md-8 d-flex align-items-center gap-3 flex-wrap">
          <Input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search by name or position"
            className="form-control"
            style={{ maxWidth: "250px" }}
          />
          <TreeModel onSelectionChange={setSelectedIds} />
        </div>

        {/* Right side: Download Button */}
        <div className="col-md-4 d-flex justify-content-end gap-3">
          <button
            className="btn btn-sm align-items-center d-flex "
            style={{ backgroundColor: "orange" }}
            onClick={() => setLoadingRef((p) => !p)}
          >
            <FeatherIconCom
              iconName={"RotateCw"}
              size={14}
              className="text-light"
            />
            <span className="px-2 text-light" style={{ fontSize: 14 }}>
              Refresh
            </span>
          </button>
          <button
            className="btn btn-sm btn-primary align-items-center d-flex "
            onClick={handleExportToExcel}
          >
            <FeatherIconCom
              iconName={"Download"}
              size={14}
              className="text-light"
            />
            <span className="px-2" style={{ fontSize: 14 }}>
              Export
            </span>
          </button>
          {/* <button
            className="btn btn-sm btn-secondary align-items-center"
            onClick={() => {
              if (!serverUrl || !APP_TOKEN) {
                toast.error("Missing server URL or token");
                return;
              }
              const base = `${serverUrl}report/DarReport`;
              const params = new URLSearchParams({
                apptoken: String(APP_TOKEN),
                date: String(startDate || ""),
                employee_id: String(myEmpId || ""),
              });
              const url = `${base}?${params.toString()}`;
              window.open(url, "_blank");
            }}
          >
            <FeatherIconCom iconName={"FileText"} size={14} className="text-light" />
            <span className="px-2 text-light" style={{ fontSize: 14 }}>
              DAR
            </span>
          </button>
        */}
          {/* <button
            className="btn btn-sm btn-info align-items-center d-flex "
            onClick={() => {
              if (!serverUrl || !APP_TOKEN) {
                toast.error("Missing server URL or token");
                return;
              }
              // Convert startDate to mm-yyyy
              let monthStr = "";
              if (startDate) {
                const d = new Date(startDate);
                if (!isNaN(d.getTime())) {
                  const mm = String(d.getMonth() + 1).padStart(2, '0');
                  const yyyy = d.getFullYear();
                  monthStr = `${mm}-${yyyy}`;
                }
              }
              const base = `${serverUrl}report/MasReport`;
              const params = new URLSearchParams({
                apptoken: String(APP_TOKEN),
                month: monthStr,
              });
              const url = `${base}?${params.toString()}`;
              window.open(url, "_blank");
            }}
          >
            <FeatherIconCom iconName={"Calendar"} size={14} className="text-light" />
            <span className="px-2 text-light" style={{ fontSize: 14 }}>
              MAS
            </span>
          </button> */}
        </div>
      </div>

      <div className="table-responsive custom-scrollbar">
        {loading ? (
          <div className="text-center py-3">
            {/* <span className="spinner-border text-primary" role="status" aria-hidden="true" /> */}
            <div>
              <Image
                className="b-r-10 img-80"
                src={dynamicImage("dashboard/loader.gif")}
                alt="Loading..."
              />
            </div>
          </div>
        ) : (
          <>
            {/* {filteredData.length > 0 && (
                        <div className="my-2">
                            <strong>Attendance:</strong>
                            {Object.entries(attendanceStats).length === 0 ? (
                                <span> No data available.</span>
                            ) : (
                                <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                                    {Object.entries(attendanceStats).map(([status, count]) => (
                                        <li key={status}>
                                            <span style={{ fontWeight: 500 }}>{status}:</span> {count}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )} */}
            {filteredData.length > 0 && (
              <div className="row g-2">
                {/* Total Employees */}
                <div className="col-lg-2 col-md-4 col-sm-6">
                  <Card
                    onClick={resetStatuses}
                    style={{
                      minHeight: "120px",
                      cursor: "pointer",
                      border:
                        selectedStatuses.length === 0
                          ? "2px solid #007bff"
                          : "1px solid #ddd",
                      backgroundColor:
                        selectedStatuses.length === 0 ? "#eef6ff" : "#fff",
                    }}
                  >
                    <CardBody
                      style={{
                        padding: "12px",
                        justifyContent: "space-between",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2"
                        style={{ display: "inline-block" }}
                      >
                        <div className="ms-3">
                          <h6
                            className="mb-1"
                            style={{
                              fontSize: "0.9rem",
                              color: "#888",
                              marginBottom: "4px",
                            }}
                          >
                            Total Active Employees
                          </h6>
                          <h3
                            className="mb-0"
                            style={{
                              fontSize: "1.4rem",
                              margin: 0,
                              fontWeight: 600,
                            }}
                          >
                            {filteredData.length}
                          </h3>
                        </div>
                      </div>
                      <div
                        className="customer mt-2"
                        style={{
                          fontSize: "0.8rem",
                          color: "#28a745",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {/* <SvgIcon
                                                iconId="arrow-up"
                                                style={{ width: '8px', height: '8px', marginRight: '4px' }}
                                            /> */}
                        {/* <h6>+ 100%</h6> */}
                      </div>
                    </CardBody>
                  </Card>
                </div>

                {/* Attendance Status Cards */}
                {Object.entries(attendanceStats).map(([status, count], idx) => {
                  const isSelected = selectedStatuses.includes(status);

                  const colorList = [
                    "success",
                    "primary",
                    "warning",
                    "danger",
                    "info",
                    "secondary",
                  ];
                  const color = colorList[idx % colorList.length];

                  const percent =
                    attendanceTable.length > 0
                      ? ((count / attendanceTable.length) * 100).toFixed(1)
                      : "0";

                  return (
                    <div className="col-lg-2 col-md-4 col-sm-6" key={status}>
                      <Card
                        onClick={() => toggleStatus(status)}
                        style={{
                          minHeight: "120px",
                          cursor: "pointer",
                          border: isSelected
                            ? "2px solid #007bff"
                            : "1px solid #ddd",
                          backgroundColor: isSelected ? "#eef6ff" : "#fff",
                        }}
                      >
                        <CardBody
                          style={{
                            padding: "12px",
                            justifyContent: "space-between",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            className={`customer-card d-flex justify-content-between align-items-center b-l-${color} border-2`}
                            style={{ gap: "8px" }}
                          >
                            <div className="ms-3">
                              <h6
                                style={{
                                  fontSize: "0.9rem",
                                  color: "#888",
                                  marginBottom: "4px",
                                }}
                              >
                                {status}
                              </h6>
                              <h3
                                style={{
                                  fontSize: "1.4rem",
                                  margin: 0,
                                  fontWeight: 600,
                                }}
                              >
                                {count}
                              </h3>
                            </div>
                          </div>
                          <div
                            className="customer mt-2"
                            style={{
                              fontSize: "0.8rem",
                              color: "#28a745",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <h6>+ {percent}%</h6>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  );
                })}
              </div>
            )}
            <CommonTableNew
              caption=""
              headData={tableHeadData}
              data={filteredData}
              //   initialRows={50} // Show 35 rows initially
              renderRow={(data, i) => (
                <tr key={i}>
                  <td>
                    <input
                      type="checkbox"
                      value={data.empid}
                      checked={selectedEIds.includes(data.empid)}
                      onChange={() => handleCheckboxChange(data.empid)}
                    />
                  </td>
                  <td>{data.empcode || "-"}</td>
                  <td
                    style={{ cursor: "pointer", color: "blue" }}
                    title="Employee Details"
                    onClick={() => {
                      if (data?.empid) {
                        // console.log(`/newProfile/${data?.empid}`);
                        navigate("/newProfile", {
                          state: {
                            employeeId: data.empid,
                            tdate: startDate,
                            positionId: data.positionId,
                          },
                        });
                      } else {
                        console.warn(
                          "Missing repCode or month",
                          data?.positionId,
                          startDate,
                        );
                      }
                    }}
                  >
                    {data.fullName || "-"}
                  </td>
                  <td
                    style={{ cursor: "pointer", color: "blue" }}
                    title="View Outlet  List"
                    onClick={() => {
                      if (data?.positionId && startDate) {
                        // console.log(`/ovpReport/${data?.positionId}`, startDate);
                        navigate(`/ovpReport/${data?.positionId}`, {
                          state: {
                            selectedMonth: startDate,
                          },
                        });
                      } else {
                        console.warn(
                          "Missing repCode or month",
                          data?.positionId,
                          startDate,
                        );
                      }
                    }}
                  >
                    {data.position || "-"}
                  </td>
                  <td>{data.AttendanceDate || "-"}</td>
                  {permissions.includes("can_do_empunlock") &&
                  data.attendanceStatus == "Day Locked" ? (
                    <td //&& data.attendanceStatus =='lock'
                      onClick={() => {
                        if (data?.empid) {
                          setSelectedEmpId(data?.empid);
                          setLockOpenModal(true);
                        }
                      }}
                      style={{ cursor: "pointer", color: "blue" }}
                    >
                      {data.attendanceStatus || "-"}
                    </td>
                  ) : (
                    <td>{data.attendanceStatus || "-"}</td>
                  )}

                  <td>{data.travelTime || "-"}</td>
                  <td>{data.travelTown || "-"}</td>
                  <td>{data?.TravelledDistance || "-"}</td>

                  <td
                    style={{ cursor: "pointer", color: "blue" }}
                    title="View Planned Patch"
                    onClick={() => {
                      setSelectedPositionId(data.positionId); // set ID
                      setModalOpen(true); // open modal
                    }}
                  >
                    {data.BeatNamesWithCount || "-"}
                  </td>
                  <td
                    // style={{ cursor: 'pointer', color: 'blue' }}
                    // title="View Actual Patch"

                    // onClick={() => {
                    //     setSelectedPositionId(data.positionId);
                    //     setModalOpen1(true);
                    // }}
                    style={{ cursor: "pointer", color: "blue" }}
                    title="Daily Activity Report"
                    onClick={() => {
                      if (data?.positionId && startDate) {
                        // console.log(`/darReport/${data?.positionId}`, startDate);
                        setModalOpen1(true);
                        if (data?.positionId && startDate) {
                          handleOpenModal(data.positionId, startDate);
                        }
                      } else {
                        console.warn(
                          "Missing repCode or month",
                          data?.positionId,
                          startDate,
                        );
                      }
                    }}
                  >
                    {data.ActualBeatNamesWithCount || "-"}
                  </td>

                  <td>{data.orderTotal}</td>
                </tr>
              )}
            />
          </>
        )}
      </div>
      <div className="d-flex justify-content-end mt-3">
        <button
          className="btn btn-primary"
          onClick={() => {
            if (selectedEIds.length > 0) {
              // console.log('Selected employee IDs:', selectedEIds);
              setModalOpen2(true);
            } else {
              toast.error("Please select employee first.");
            }
          }}
        >
          Send Notification
        </button>
      </div>
      <CommonModal
        isOpen={lockOpenModal}
        toggle={() => setLockOpenModal(false)}
        title="Do you want to unlock this day?"
        size="md"
      >
        <div className="p-3 ">
          {/* <h5>Do you want to unlock this account?</h5> */}
          {/* <p>Employee ID: <strong>{selectedEmpId}</strong></p> */}

          <div className="mb-3">
            <h5>
              Remark <span className="text-danger">*</span>
            </h5>
            <textarea
              className="form-control"
              placeholder="Enter remark"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </div>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button
              className="btn btn-success"
              onClick={handleSubmits}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Unlock"}
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setLockOpenModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </CommonModal>
      <CommonModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        title="Planned Patch"
      >
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Patch</th>
                <th>Type</th>
                <th>Name</th>
                <th>Vf.</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="text-center py-3">
                    <img
                      src={dynamicImage("dashboard/loader.gif")}
                      alt="Loading..."
                      style={{ width: "50px" }}
                    />
                  </td>
                </tr>
              ) : callsTable.length > 0 ? (
                callsTable.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row?.["Beats.BeatName"]}</td>
                    <td>{row.OutletTypeName}</td>
                    <td>{row.OutletName}</td>
                    <td>{row.VisitFq}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CommonModal>

      <CommonModal
        size="xl"
        isOpen={modalOpen1}
        toggle={() => setModalOpen1(false)}
        title="Daily Activity Report"
      >
        {/* <DARReport positionId={String(data?.positionId)} startDate={startDate} /> modal-fullscreen */}
        <DARReport
          positionId={reportData.positionId}
          startDate={reportData.startDate}
        />
        {/* <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Type </th>
                                <th>Name </th>
                                <th>DCR Status </th>
                            </tr>
                        </thead>
                        <tbody>
                            {callsTable1.length > 0 ? (
                                callsTable1.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.OutletTypeName}</td>
                                        <td>{row.OutletName}</td>
                                        <td>{row.DcrStatus}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}


                        </tbody>
                    </table>
                </div> */}
      </CommonModal>

      <CommonModal
        isOpen={modalOpen2}
        toggle={() => setModalOpen2(false)}
        title="Send Push Notification"
      >
        <div className="p-3">
          <div className="mb-3">
            <label className="form-label">Title</label>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter notification title"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Message</label>
            <textarea
              className="form-control"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter notification message"
            />
          </div>
          <div className="d-flex justify-content-end">
            <button className="btn btn-primary" onClick={handleSubmit}>
              Send
            </button>
          </div>
        </div>
      </CommonModal>
    </Fragment>
  );
}
